import { render, staticRenderFns } from "./AssetManagerv2.vue?vue&type=template&id=c6381cea&scoped=true&"
import script from "./AssetManagerv2.vue?vue&type=script&lang=js&"
export * from "./AssetManagerv2.vue?vue&type=script&lang=js&"
import style0 from "./AssetManagerv2.vue?vue&type=style&index=0&id=c6381cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6381cea",
  null
  
)

export default component.exports